"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationContentManagementService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var JsonApi_service_1 = require("./JsonApi.service");
var CollaborationContentManagementService = /** @class */ (function () {
    function CollaborationContentManagementService(jsonApiService) {
        this.jsonApiService = jsonApiService;
    }
    CollaborationContentManagementService.prototype.createFolder = function (item) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'CreateFolder', item, {
            retryCallback: function () { return _this.createFolder(item); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.addContent = function (folderId, content) {
        var _this = this;
        var fullPath = '';
        if (content && content.BasicInfo && content.BasicInfo.FullPath) {
            fullPath = content.BasicInfo.FullPath;
        }
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'AddContent', content, {
            query: {
                folderid: folderId.Id,
                createnewversion: false,
                doccenterFullPath: fullPath,
            },
            retryCallback: function () { return _this.addContent(folderId, content); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.updateContent = function (isNewVersion, content) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'UpdateContent', content, {
            query: {
                iscreatenewversion: isNewVersion,
            },
            retryCallback: function () { return _this.updateContent(isNewVersion, content); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.deleteContents = function (toDelContents) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'DeleteContents', toDelContents, {
            retryCallback: function () { return _this.deleteContents(toDelContents); },
        });
    };
    CollaborationContentManagementService.prototype.lockContents = function (toLockContentIds) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'LockContents', toLockContentIds, {
            retryCallback: function () { return _this.lockContents(toLockContentIds); },
        });
    };
    CollaborationContentManagementService.prototype.unlockContents = function (toUnlockContentIds) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'UnlockContents', toUnlockContentIds, {
            retryCallback: function () { return _this.unlockContents(toUnlockContentIds); },
        });
    };
    CollaborationContentManagementService.prototype.emptyFolder = function (folderId) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentManagementServiceV2', 'EmptyFolder', {
            query: {
                folderId: folderId,
            },
            retryCallback: function () { return _this.emptyFolder(folderId); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.moveContents = function (targetfolderid, toMoveContents) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'MoveContents', toMoveContents, {
            query: {
                targetfolderid: targetfolderid,
            },
            retryCallback: function () { return _this.moveContents(targetfolderid, toMoveContents); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.copyContents = function (targetfolderid, toCopyContents) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'CopyContentsToFolder', toCopyContents, {
            query: {
                targetfolderid: targetfolderid,
            },
            retryCallback: function () { return _this.copyContents(targetfolderid, toCopyContents); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.uploadFile = function (fileUploadInfo) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'UploadFile', fileUploadInfo, {
            retryCallback: function () { return _this.uploadFile(fileUploadInfo); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.addContentForUpload = function (collaborationUploadInput) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'AddContentForUpload', collaborationUploadInput, {
            retryCallback: function () { return _this.addContentForUpload(collaborationUploadInput); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.createGoogleNewRevision = function (collaborationUploadInput) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'CreateGoogleNewRevision', collaborationUploadInput, {
            retryCallback: function () { return _this.createGoogleNewRevision(collaborationUploadInput); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CollaborationContentManagementService.prototype.checkCollaborationNameCollisionForClient = function (intentNames) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'CheckCollaborationNameCollisionForClient', intentNames, {
            retryCallback: function () { return _this.checkCollaborationNameCollisionForClient(intentNames); },
        });
    };
    CollaborationContentManagementService.prototype.setAsLatestVersion = function (versionId) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentManagementServiceV2', 'SetAsLatestVersion', {
            query: {
                versionid: versionId,
            },
            retryCallback: function () { return _this.setAsLatestVersion(versionId); },
        });
    };
    CollaborationContentManagementService.prototype.follow = function (contentId) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'Follow', contentId, {
            retryCallback: function () { return _this.follow(contentId); },
        });
    };
    CollaborationContentManagementService.prototype.unFollow = function (contentId) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentManagementServiceV2', 'UnFollow', contentId, {
            retryCallback: function () { return _this.unFollow(contentId); },
        });
    };
    CollaborationContentManagementService = __decorate([
        CommonService_decorator_1.CommonService('CollaborationContentManagementService'),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService])
    ], CollaborationContentManagementService);
    return CollaborationContentManagementService;
}());
exports.CollaborationContentManagementService = CollaborationContentManagementService;
//# sourceMappingURL=CollaborationContentManagement.service.js.map